module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-e22bee239afb0b7947667eaf50a48d30.webp";